import React from 'react';
import { Box, Container, Typography, Grid, Card, CardMedia, CardContent } from '@mui/material';
import {siteConfig} from "../../config/siteConfig";

const VehicleShowcase = ({ vehicles }) => {
    return (
        <Box sx={{
            py: 10,
            bgcolor: siteConfig.colors.secondary,
            color: 'white'
        }}>
            <Container maxWidth="xl">
                {/* Title Section */}
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                            '& span': {
                                color: siteConfig.colors.primary
                            }
                        }}
                    >
                        Unsere <span>Fahrzeuge</span>
                    </Typography>

                    <Box sx={{
                        width: '80px',
                        height: '4px',
                        bgcolor: siteConfig.colors.primary,
                        margin: '0 auto',
                        mb: 3
                    }} />

                    <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                        Entdecken Sie einige der Fahrzeuge, die wir optimiert haben
                    </Typography>
                </Box>

                {/* Vehicle Cards Grid */}
                <Grid container spacing={4}>
                    {vehicles.map((vehicle, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <Card
                                sx={{
                                    height: '100%',
                                    bgcolor: 'transparent',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderRadius: 3,
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-10px)',
                                        '& .overlay': {
                                            opacity: 0.8
                                        }
                                    }
                                }}
                                elevation={0}
                            >
                                {/* Vehicle Image */}
                                <CardMedia
                                    component="img"
                                    image={vehicle.image}
                                    alt={vehicle.model}
                                    sx={{
                                        height: 400,
                                        objectFit: 'cover',
                                    }}
                                />

                                {/* Dark Overlay */}
                                <Box
                                    className="overlay"
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        bgcolor: 'rgba(0,0,0,0.5)',
                                        opacity: 0.6,
                                        transition: 'opacity 0.3s ease'
                                    }}
                                />

                                {/* Content Overlay */}
                                <CardContent
                                    sx={{
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        color: 'white',
                                        p: 3,
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 70%, transparent 100%)'
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: 'bold',
                                            mb: 2
                                        }}
                                    >
                                        {vehicle.model}
                                    </Typography>

                                    {/* Performance Stats */}
                                    <Box sx={{ display: 'flex', gap: 4 }}>
                                        <Box>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: siteConfig.colors.primary,
                                                    display: 'block',
                                                    mb: 0.5,
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                Leistung
                                            </Typography>
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                +{vehicle.power} PS
                                            </Typography>
                                        </Box>

                                        <Box>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: siteConfig.colors.primary,
                                                    display: 'block',
                                                    mb: 0.5,
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                Drehmoment
                                            </Typography>
                                            <Typography
                                                variant="h6"
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                +{vehicle.torque} Nm
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default VehicleShowcase;